/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconYml16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYml16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 17 17" ref={ref}>
            <mask
                id="dc-Yml16-a"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-a)">
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L11.803 2.87 9.926.243Z"
                    fill="#29B5B7"
                />
            </g>
            <mask
                id="dc-Yml16-b"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-b)">
                <path d="M10.256 4.418 14.43 8.59V4.747l-4.174-.33Z" fill="url(#dc-Yml16-c)" />
            </g>
            <mask
                id="dc-Yml16-d"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-d)">
                <path d="M9.928.243v3.378c0 .622.504 1.126 1.126 1.126h3.377L9.928.243Z" fill="#73E4E5" />
            </g>
            <mask
                id="dc-Yml16-e"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-e)">
                <path
                    d="M3.546.243A1.13 1.13 0 0 0 2.42 1.37v.094c0-.62.507-1.126 1.126-1.126h6.38V.243h-6.38Z"
                    fill="#fff"
                    fillOpacity=".2"
                />
            </g>
            <mask
                id="dc-Yml16-f"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-f)">
                <path
                    d="M13.304 16.663H3.546a1.13 1.13 0 0 1-1.126-1.126v.094c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126v-.094a1.13 1.13 0 0 1-1.126 1.126Z"
                    fill="#263238"
                    fillOpacity=".2"
                />
            </g>
            <mask
                id="dc-Yml16-g"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="13"
                height="17"
            >
                <path
                    d="M9.926.243h-6.38A1.13 1.13 0 0 0 2.42 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.926.243Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml16-g)">
                <path
                    d="M11.054 4.747A1.126 1.126 0 0 1 9.928 3.62v.094c0 .622.504 1.126 1.126 1.126h3.377v-.094h-3.377Z"
                    fill="#263238"
                    fillOpacity=".1"
                />
            </g>
            <path
                d="M9.928.243h-6.38A1.13 1.13 0 0 0 2.422 1.37v14.262c0 .62.507 1.126 1.126 1.126h9.758a1.13 1.13 0 0 0 1.126-1.126V4.747L9.928.243Z"
                fill="url(#dc-Yml16-h)"
            />
            <rect x="1" y="7" width="14" height="6" rx="1" fill="#1B77B1" />
            <path
                d="M4.265 10.366V12h-.906v-1.634L2 8h.975l.935 1.715L4.874 8h.743l-1.352 2.366ZM9.548 9.019l-1.01 2.463h-.674l-.998-2.504V12h-.68V8h1.08l1.045 2.555L9.351 8h1.103v4h-.906V9.019ZM14 12h-2.665V8h.906v3.43H14V12Z"
                fill="#fff"
            />
            <defs>
                <radialGradient
                    id="dc-Yml16-h"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.802 .571) scale(19.3659)"
                >
                    <stop stopColor="#fff" stopOpacity=".1" />
                    <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="dc-Yml16-c"
                    x1="12.343"
                    y1="4.776"
                    x2="12.343"
                    y2="8.592"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#263238" stopOpacity=".2" />
                    <stop offset="1" stopColor="#263238" stopOpacity=".02" />
                </linearGradient>
            </defs>
        </SVGContainer>
    );
});

const IconYml24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYml24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <mask
                id="dc-Yml24-a"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="0"
                width="18"
                height="24"
            >
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701L14.012.343Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml24-a)">
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701l-3.71-2.649L14.013.343Z"
                    fill="#25B4B6"
                />
            </g>
            <mask
                id="dc-Yml24-b"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="0"
                width="18"
                height="24"
            >
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701L14.012.343Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml24-b)">
                <path d="m14.479 6.237 5.893 5.892V6.7l-5.893-.464Z" fill="url(#dc-Yml24-c)" />
            </g>
            <mask
                id="dc-Yml24-d"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="0"
                width="18"
                height="24"
            >
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701L14.012.343Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml24-d)">
                <path d="M14.014.343v4.769c0 .878.711 1.59 1.59 1.59h4.768L14.014.342Z" fill="#6BE2E4" />
            </g>
            <mask
                id="dc-Yml24-e"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="0"
                width="18"
                height="24"
            >
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701L14.012.343Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml24-e)">
                <path
                    d="M5.006.343c-.875 0-1.59.716-1.59 1.59v.132c0-.874.715-1.59 1.59-1.59h9.007V.344H5.006Z"
                    fill="#fff"
                    fillOpacity=".2"
                />
            </g>
            <mask
                id="dc-Yml24-f"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="0"
                width="18"
                height="24"
            >
                <path
                    d="M14.013.343H5.006c-.875 0-1.59.716-1.59 1.59v20.134c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59V6.701L14.012.343Z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#dc-Yml24-f)">
                <path
                    d="M18.782 23.524H5.006c-.875 0-1.59-.715-1.59-1.59v.133c0 .874.715 1.59 1.59 1.59h13.776c.874 0 1.59-.716 1.59-1.59v-.132c0 .874-.716 1.59-1.59 1.59Z"
                    fill="#263238"
                    fillOpacity=".2"
                />
            </g>
            <path
                d="M14.017.343H5.009c-.874 0-1.59.716-1.59 1.59v20.134c0 .875.716 1.59 1.59 1.59h13.777c.874 0 1.59-.715 1.59-1.59V6.702L14.015.343Z"
                fill="url(#dc-Yml24-g)"
            />
            <rect x="2" y="10" width="20" height="8" rx="1" fill="#1B77B1" />
            <path
                d="M6.397 14.548V17H5.038v-2.452L3 11h1.463l1.403 2.573L7.31 11h1.115l-2.03 3.548ZM14.322 12.528l-1.515 3.695h-1.01l-1.499-3.755V17H9.28v-6h1.62l1.568 3.833L14.027 11h1.654v6h-1.359v-4.472ZM21 17h-3.998v-6h1.359v5.145H21V17Z"
                fill="#fff"
            />
            <defs>
                <radialGradient
                    id="dc-Yml24-g"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(3.957 .807) scale(27.3401)"
                >
                    <stop stopColor="#fff" stopOpacity=".1" />
                    <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="dc-Yml24-c"
                    x1="17.425"
                    y1="6.742"
                    x2="17.425"
                    y2="12.129"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#263238" stopOpacity=".2" />
                    <stop offset="1" stopColor="#263238" stopOpacity=".02" />
                </linearGradient>
            </defs>
        </SVGContainer>
    );
});

export const IconYml = forwardRef<SVGSVGElement, IconBaseProps>(function IconYml(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconYml16 {...iconProps} />;
        case '24':
            return <IconYml24 {...iconProps} />;
        default:
            return <IconYml24 {...iconProps} />;
    }
});
